import ItemBox from "../../app-instantsearch/components/ItemBox.tsx";
import { useHits, type UseHitsProps } from "react-instantsearch";
import { useEnrichedProducts } from "../../hooks/useEnrichedProducts.ts";
import { useUIContext } from "../providers/UIProvider.tsx";
import type { AlgoliaAttributes } from "../../types/AlgoliaAttributes";
import { useDateFilterContext } from "../providers/DateFilterProvider.tsx";

export function ItemList(props: UseHitsProps<AlgoliaAttributes>) {
	const { items, sendEvent } = useHits(props);
	const enrichedItems = useEnrichedProducts(items);
	const { isActive } = useUIContext();
	const { startDate, endDate } = useDateFilterContext();

	if (!enrichedItems || enrichedItems.length === 0) {
		return null;
	}

	const normalizedStart = startDate ? new Date(startDate.setHours(0, 0, 0, 0)) : null;
	const normalizedEnd = endDate ? new Date(endDate.setHours(0, 0, 0, 0)) : null;

	const filtered = enrichedItems.filter(hit => {
		if (!normalizedStart || !normalizedEnd) return true;
		if (hit.isVideo) return true;

		const zeitraumArray = Array.isArray(hit["attributes.Zeitraum"])
			? hit["attributes.Zeitraum"]
			: [];

		return zeitraumArray.some((entry: string) => {
			const [start, end] = parseDateRange(entry);
			return start <= normalizedEnd && end >= normalizedStart;
		});
	});

	function parseDateRange(entry: string): [Date, Date] {
		const parts = entry.split("-").map(p => p.trim());
		const start = parseGermanDate(parts[0]);
		const end = parts[1] ? parseGermanDate(parts[1]) : start;
		return [start, end];
	}

	function parseGermanDate(str: string): Date {
		const [d, m, y] = str.split(".").map(n => parseInt(n, 10));
		if (!d || !m || !y) return new Date(NaN);
		return new Date(y, m - 1, d);
	}


	return (
		<ol className={`ais-itemList ${isActive ? "is-active" : ""}`} tabIndex={-1} suppressHydrationWarning>
			{filtered.map((hit) => (
				<ItemBox hit={hit} sendEvent={sendEvent} key={hit.objectID} />
			))}
		</ol>
	);
}
